import React, { useCallback, useEffect, useMemo } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import Header from "../../../policy/fragments/heading/index";
import { useIntl, FormattedMessage } from "react-intl";
import { Iconfont } from "../../../../components/icon/iconfont";
import { useState } from "react";
import List from "../../../listing/components/list";
import { useDispatch, useSelector } from "react-redux";
import { action_append_wishlist, action_fetch_wishlist_count, action_fetch_wishlist_filter, action_fetch_wishlist_filter_count, action_init_wishlist, initWishList, setCustomerLoading } from "../../../../../store/actions/pages/customer";
import _ from "lodash";
import { useStore } from "react-redux";
import { useParams } from "react-router-dom";
import { useQuery } from "../../../../hooks/common";
import { useRef } from "react";
import { BigButton } from "../../../../components/button";
import NormalConfigConfirm from "../../../../components/alert/config-confirm";
import { fetchGetMessage, removeExpiredProducts, removeWishListProduct } from "../../../../../api";
import { action_fetch_cart_count, setWishList } from "../../../../../store/actions/global";
import ProductYouLikes from "../../../details/module/youlikes";
import { CartCountIcon } from "../../../shoppingcart/pages/collect-order/components/cart-count-icon";
import { WishSortFilter } from "./components/sorter";
import deeplink from "../../../../../utils/deeplink";

const WishList = props =>{
    useStyles(cls);
    const Intl = useIntl();
    const [wishListSelect, setWishListSelect] = useState(false);
    const store = useStore();
    const params = useParams();
    const query = useQuery();

    const dispatch = useDispatch();
    const pageCustomer = useSelector(state=>state.pageCustomer);
    const global = useSelector(state => state.global)
    const {
        loading,
        wishListFilter,
        wishListFilterResult,
        wishListLoading,
        wishListFinished,
        wishListCount,
        wishListFilterCount,
    } = pageCustomer;
    const { countCart, wishlist } = global
    const idsRef = useRef([]);
    const [showYMAL, setShowYMAL] = useState(false)
    const [filterVO, setFilterVO] = useState()

    const [filterItems, setFilterItems] = useState(null)
    const [filterParamsBasic, setFilterParamsBasic] = useState({"limit":20})
    // const [filterParams, setFilterParams] = useState({"limit":20})
    const filterParams = useRef({"limit":20})
    const filterParamsSensor = useRef({"limit":20})

    const [statuses, setStatuses] = useState()
    const [categories, setCategories] = useState()
    const [sorters, setSorters] = useState()
    const [status, setStatus] = useState()
    const [category,setCategory] = useState()
    const [sorter, setSorter] = useState()
    const [goShoppingUrl, setGoShoppingUrl] = useState('/')
    const [showFilterHead, setShowFilterHead] = useState(true)
    const [showFilter, setShowFilter] = useState(false)
	const [filterMaskData, setFilterMaskData] = useState(null)

    useEffect(async () => {
        if (window.__INITIAL_STATE__) {
			// Allow the passed state to be garbage-collected
			delete window.__INITIAL_STATE__
		} else {
            // if(!wishListFilterResult || wishListFilterResult?.length <= 0){
            await WishList.fetchData(store, params, query)
            // }
        }

        await dispatch(action_fetch_wishlist_count())
        await dispatch(action_fetch_wishlist_filter_count())

        getCartCount()
        getGoShoppingUrl()
        return () =>{
            idsRef.current = [];
        }
    }, []);

    useEffect(() => {
        if(wishListFilter?.sorter){
            wishListFilter?.sorter?.selections && setSorters(wishListFilter?.sorter)
            wishListFilter?.sorter?.defaultValue && setSorter(wishListFilter?.sorter.defaultValue)
        }
        if(wishListFilter?.filter?.filterItems){
            const filterItems = wishListFilter?.filter?.filterItems
            const categoryFilter = filterItems?.find(f => f?.fieldName == 'category_ids') || null
            const statusFilter = filterItems?.find(f => f?.fieldName == 'status') || null
            setFilterVO(wishListFilter)
            setCategories(categoryFilter)
            setStatuses(statusFilter)
        }
    }, [wishListFilter])

    useEffect(() => {
        if(wishListFinished){
            setShowYMAL(true)
        } else {
            setShowYMAL(false)
        }
    }, [wishListFinished])

    const getCartCount = () => {
        dispatch(action_fetch_cart_count())
    }

    const getGoShoppingUrl = () => {
        fetchGetMessage('M1794').then(res => {
            if(res?.code == 200 && res?.result?.message){
                let obj = JSON.parse(res?.result?.message)
                setGoShoppingUrl(deeplink(obj))
            }
        })
    }

    const loadHandle = useCallback(_.debounce(async () =>{
        dispatch(action_append_wishlist(filterParams.current));
    }, 400), [filterParams.current]);

    const wishListSelectEvent = useCallback((id) =>{
        idsRef.current.push(id);
    }, []);

    const handleDelete = useCallback(async () =>{
        dispatch(setCustomerLoading(true));
        let response;
        if(idsRef.current?.length > 0){
            response = await removeWishListProduct(idsRef.current.join(","));
        }else{
            response = await removeExpiredProducts();
        }
        let products = [...wishListFilterResult];
        let afterDeleteProducts = products?.filter(p => idsRef.current?.indexOf(p?.id) == -1 )
        let afterDeleteWishList = wishlist?.filter(w => idsRef.current?.indexOf(w) == -1)
        if(afterDeleteProducts?.length < 1){
            setWishListSelect(false)
        }
        dispatch(setWishList(afterDeleteWishList))
        dispatch(initWishList(afterDeleteProducts))
        dispatch(action_fetch_wishlist_count())
        idsRef.current = [];
        dispatch(setCustomerLoading(false));
    }, [wishListFilterResult, idsRef.current]);

    const cancelSaveHandle  = () =>{
        NormalConfigConfirm({
            message:{
                text:Intl.formatMessage({ id: "sure_delete_items", defaultMessage: "Are you sure you want to delete the item(s)?" })
            },
            btn1:{
                clickHandle:() =>{
                    handleDelete();
                }
            },
            btn2:{
            }
        });

        // 多选确认点击
        if(window.GeekoSensors){
            window.GeekoSensors.Track('WishlistButtonClick', {
                page_sort:"wish list",
                page_type: "收藏夹页",
                button_pv:"delete_multi",
                is_success:true
            })
        }
    }

    const headerCenterSlot = useMemo(() => {
        return (
            <div className={cls.CenterTitle}>
                <div>
                    {Intl.formatMessage({ id: "wishlist", defaultMessage: "Wishlist" })}
                </div>
                <div className={cls.WishNum}>
                    {wishListCount || 0}
                    {' '}
                    {
                        wishListCount > 1?
                        Intl.formatMessage({ id: "items", defaultMessage: "items" }):
                        Intl.formatMessage({ id: "item", defaultMessage: "item" })
                    }
                </div>
            </div>
        )
        // 就是用 wishlistCount 没看错
    }, [wishListCount])

    const headerRightSlot = useMemo(() => {
        return (
            <div className={cls.RightSlot}>
                {
                    wishListFilterResult?.length > 0 &&
                    <div className={cls.RightIcon} onClick={()=>setWishListSelect(state=>!state)}>
                        {
                            wishListSelect ?
                            <span className={cls.CancleFont}><FormattedMessage id="cancel" defaultMessage="Cancel" /></span> :
                            <Iconfont className={cls.Icon}>&#xe6eb;</Iconfont>
                        }
                    </div>
                }
                {
                    !wishListSelect && <CartCountIcon cartCount={countCart} href={'/cart'}/>
                }
            </div>
        )
    }, [wishListFilterResult, wishListSelect, countCart])

    const resetFilterParams = async () => {
        // setFilterParams(() => {return {...filterParamsBasic}})
        setSorter(sorters?.selections?.[0]?.value)
        filterParams.current = {...filterParamsBasic}
        filterParamsSensor.current = {...filterParamsBasic}
        // 重新请求一遍
        await dispatch(action_init_wishlist(filterParamsBasic))
        dispatch(action_fetch_wishlist_filter_count(filterParamsBasic))
    }

    const sorterChange = async ( data, sorter ) => {
        setSorter(data)
        // let params = {...filterParams.current, sorter: data}
        let params, sensorParams
        let prevPraramsFilter = filterParams.current?.filter
        if(prevPraramsFilter){
            params = {...(filterParams.current || {}), filter: {...(filterParams.current?.filter || {}), sorter: data}}
            sensorParams = {...(filterParamsSensor.current || {}), filter: {...filterParamsSensor.current?.filter, sorter: sorter}}
        } else {
            params = {...(filterParams.current || {}), filter: {...(filterParams.current?.filter || {}), sorter: data}}
            sensorParams = {...(filterParamsSensor.current || {}), filter: {...filterParamsSensor.current?.filter, sorter: sorter}}
        }
        // setFilterParams(() => {return params})
        filterParams.current = params
        filterParamsSensor.current = sensorParams
        await dispatch(action_init_wishlist(params))
    }

    const categoryChange = async ( data, rawData, type ) => {
        let params
        let baseData = {
            fieldName: rawData?.fieldName,
            selections: [...(data || [])]
        }
        if(!type || type == 'done'){
            setCategory(data)
            let prevFilterParams = [...(filterParams.current?.filter?.filterItems || [])]
            if(prevFilterParams?.find(p => p?.fieldName?.toLocaleLowerCase()?.indexOf('category') != -1)){
                let prevFilterParams1 = prevFilterParams?.filter(p => p && p?.fieldName?.toLocaleLowerCase()?.indexOf('category') == -1)
                prevFilterParams = [...prevFilterParams1, baseData]
            } else {
                prevFilterParams = [...prevFilterParams, baseData]
            }
            params = {...filterParams.current, filter: {...(filterParams.current?.filter || {}), filterItems:prevFilterParams}}
            if(type == 'done'){
                // setFilterParams(() => {return params})
                filterParams.current = params
                filterParamsSensor.current = params
                await dispatch(action_init_wishlist(params))
            }
        } else if(type == 'clear'){
            let prevFilterParams = [...(filterParams.current?.filter?.filterItems || [])]
            let prevFilterParams1 = prevFilterParams?.filter(p => p && p?.fieldName?.toLocaleLowerCase()?.indexOf('category') == -1)
            params = {...filterParams.current, filter: {...(filterParams.current?.filter || {}), filterItems:prevFilterParams1}}
            setCategory(null)
            // setFilterParams(() => {return params})
            filterParams.current = params
            filterParamsSensor.current = params
            await dispatch(action_init_wishlist(params))
        }
        dispatch(action_fetch_wishlist_filter_count(params))
    }

    const statusChangeFunc = async ( data, rawData, type ) => {
        let params
        let baseData = {
            fieldName: rawData?.fieldName,
            selections: [...(data || [])]
        }
        if(!type || type == 'done' || type == 'tag'){
            let prevFilterParams = [...(filterParams.current?.filter?.filterItems || [])]
            if(prevFilterParams?.find(p => p?.fieldName?.toLocaleLowerCase()?.indexOf('status') != -1)){
                let prevFilterParams1 = prevFilterParams?.filter(p => p && p?.fieldName?.toLocaleLowerCase()?.indexOf('status') == -1)
                prevFilterParams = [...prevFilterParams1, baseData]
            } else {
                prevFilterParams = [...prevFilterParams, baseData]
            }
            params = {...filterParams.current, filter: {...(filterParams.current?.filter || {}), filterItems:prevFilterParams}}
            setStatus(data)
            if(type){
                // setFilterParams(() => {return params})
                filterParams.current = params
                filterParamsSensor.current = params
                await dispatch(action_init_wishlist(params))
            }
        } else if(type == 'clear'){
            let prevFilterParams = [...(filterParams.current?.filter?.filterItems || [])]
            let prevFilterParams1 = prevFilterParams?.filter(p => p && p?.fieldName?.toLocaleLowerCase()?.indexOf('status') == -1)
            params = {...filterParams.current, filter: {...(filterParams.current?.filter || {}), filterItems:prevFilterParams1}}
            setStatus(null)
            // setFilterParams(() => {return params})
            filterParams.current = params
            filterParamsSensor.current = params
            await dispatch(action_init_wishlist(params))
        }
        dispatch(action_fetch_wishlist_filter_count(params))
    }

    const filterSubmit = async ( data ) => {
        let prevFilterParams
		const priceOfData = data?.find(v => v?.fieldName == 'price')
		if(priceOfData){
            const otherData = data?.filter(d => d?.fieldName != 'price')
            prevFilterParams = [...(otherData || [])]
		} else {
            prevFilterParams = [...(data || [])]
        }
        let params = {...filterParams.current, filter: {...(filterParams.current?.filter || {}), filterItems:prevFilterParams, endPrice: priceOfData?.endPrice, startPrice: priceOfData?.startPrice}}
        // setFilterParams(() => {return params})
        const filterSubmitCategory = data?.find(d => d?.fieldName == 'category_ids')
        if(filterSubmitCategory?.selections){
            setCategory(filterSubmitCategory?.selections)
        }
        const filterSubmitStatus = data?.find(d => d?.fieldName == 'status')
        if(filterSubmitStatus?.selections){
            setStatus(filterSubmitStatus?.selections)
        }
        filterParams.current = params
        filterParamsSensor.current = params
        await dispatch(action_init_wishlist(params))
    }

    const sensorFilter = useMemo(() => {
        const paramsData = filterParamsSensor.current
        const paramsFilter = paramsData ? paramsData?.filter?.filterItems || [] : []
        const categoryOfFilterParams = paramsFilter?.find(f => f?.fieldName == 'category_ids') || null
        const statusOfFilterParams = paramsFilter?.find(f => f?.fieldName == 'status') || null
        const otherOfFilterParams = paramsFilter?.filter(f => f?.fieldName != 'status' && f?.fieldName != 'category_ids') || null
        let sorter = paramsData?.filter?.sorter?.enLabel || paramsData?.filter?.sorter?.value || wishListFilter?.sorter?.selections?.[0]?.enLabel || wishListFilter?.sorter?.selections?.[0]?.label || '0'
        let category = categoryOfFilterParams?.selections?.map(s => {return s?.enLabel || s?.label || s.value})?.join(',') || ''
        let status = statusOfFilterParams?.selections?.map(s => {return s?.enLabel || s?.label || s.value})?.join(',') || ''
        let filter = otherOfFilterParams?.map(o => {return o?.selections?.map(os => {return os?.enLabel || os?.label || os?.value})})?.filter(od => !!od)?.join(',') || ''
        let price = paramsData?.filter?.startPrice && paramsData?.filter?.endPrice ?
                    [paramsData?.filter?.startPrice || 0, paramsData?.filter?.endPrice || 0]:
                    [wishListFilter?.filter?.minPrice?.amount || 0, wishListFilter?.filter?.maxPrice?.amount || 0]
        let output = `${sorter?'sorter:'+sorter+';':''}${filter?'filter:'+filter+';':''}${category?'category:'+category+';':''}${status?'status:'+status+';':''}${price?'price:['+price+']':''}`
        return output
    }, [filterParamsSensor.current, wishListFilter])

    useEffect(() => {
        if(
            wishListFilterResult?.length > 0 ||
            wishListLoading ||
            (Object.keys(filterParams.current)?.length > 1 && wishListFilterResult?.length <= 0)
        ){
            setShowFilterHead(true)
        } else {
            setShowFilterHead(false)
        }
    }, [wishListFilterResult, wishListLoading])

    return <div className={cls.WishListPage}>
        <Header
            centerSlot={headerCenterSlot}
            rightSlot={headerRightSlot}
        />

        {
            showFilterHead &&
            <WishSortFilter
                filters={filterItems}
                filterVo={filterVO}
                statuses={statuses}
                statusData={status}
                statusChangeFunc={statusChangeFunc}
                categories={categories}
                category={category}
                categoryChange={categoryChange}
                sorters={sorters}
                sorter={sorter}
                sorterChange={sorterChange}
                setSorter={setSorter}
                wishListFilterCount={wishListFilterCount === null? wishListCount: wishListFilterCount}
                filterSubmit={filterSubmit}
                filterParams={filterParams.current}
                resetFilterParams={resetFilterParams}
                updateFilterResultCount={() => {
                    dispatch(action_fetch_wishlist_filter_count(filterParams.current))
                }}
                showFilter={showFilter}
                setShowFilter={setShowFilter}
                filterMaskData={filterMaskData}
                setFilterMaskData={setFilterMaskData}
                />
        }

        {
            wishListFilterResult?.length > 0 || wishListLoading ?
            <React.Fragment>
                <List
                    request={loadHandle}
                    finished={wishListFinished}
                    loading={wishListLoading}
                    products={wishListFilterResult}
                    sensors={{
                        resourcepage_title: 'wishlist',
                        resource_position: '1',
                        resource_type: '11',
                        resource_content: 'wishlist',
                        filter: sensorFilter
                    }}
                    ingoreCard
                    isWishList
                    hideFinishedTxt
                    wishListSelect={wishListSelect}
                    wishListSelectEvent={wishListSelectEvent}
                />
                {/* {
                    wishListFinished &&
                    <div className={cls.Finished}>
                        <FormattedMessage id="no_more_data" defaultMessage="No more data" />.
                    </div>
                } */}
            </React.Fragment>:
            <React.Fragment>
                {
                    Object.keys(filterParams.current)?.length > 1?
                    <div className={cls.Empty}>
                        <Iconfont className={cls.EmptyIcon}>&#xe6e7;</Iconfont>
                        <div className={cls.EmptyTip}>
                            <FormattedMessage id="wish_list_filter_empty" defaultMessage={"No results found. Consider trying different options."}/>
                        </div>
                        <div className={cls.EmptyButton} onClick={() => resetFilterParams()}>
                            <FormattedMessage id="reset" defaultMessage={"Reset"}/>
                        </div>
                    </div>:
                    <div className={cls.Empty}>
                        <Iconfont className={cls.EmptyIcon}>&#xe6e7;</Iconfont>
                        <div className={cls.EmptyTip}>
                            <FormattedMessage id="wish_list_nothing" defaultMessage={"You currently have nothing saved.\"Heart\" an item to start your wishlist."}/>
                        </div>
                        <div className={cls.EmptyButton} onClick={() => window.location.href = goShoppingUrl}>
                            <FormattedMessage id="go_shopping" defaultMessage={"Go Shopping"}/>
                        </div>
                    </div>
                }
            </React.Fragment>
        }

        {
            !(Object.keys(filterParams.current)?.length > 1 && wishListFilterResult?.length <= 0) && showYMAL &&
            <div className={cls.YMALBox}>
                <ProductYouLikes
                    titleStyle={{textAlign: 'left', paddingLeft: 12, background: '#fff', position: 'relative', zIndex: 2}}
                    limitRequest={100}
                    affixHead={true}
                    affixHeadOffset={44}
                    sensors={{
                        resourcepage_title: 'wishlist',
                        resource_position: "1",
                        resource_type: "4",
                        resource_content: "You may also like",
                        filter: sensorFilter
                    }}
                    />
            </div>
        }

        {
            <div className={cls.FixedOption} style={{ display: `${wishListSelect?'block':'none'}` }}>
                <BigButton loading={loading} className={cls.DeleteBtn} onClick={cancelSaveHandle}><FormattedMessage id="delete" defaultMessage="Delete" /></BigButton>
            </div>
        }
    </div>
}

WishList.fetchData = async (store, params, search, headers) => {
    const filter = {
        limit: 20
    }
    const fetchWishListResult = store.dispatch(action_init_wishlist(filter, headers))
    const getWishListFilter = store.dispatch(action_fetch_wishlist_filter(headers))
    const result = await Promise.all([fetchWishListResult, getWishListFilter])
    return result
}

export default WishList;